import React from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTokenInfo } from "../../../utils/Guard";
import { useNavigate } from "react-router-dom";
import { CreateUser, GetUsers } from "../../../store/user-store/user-actions";
import { Button } from "primereact/button";
import ABADatatable from "../../../components/ABADataTable/ABADatatable";
import { Dialog } from "primereact/dialog";
import UserForms from "../../../components/Forms/UserForms";


const SignUsers = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userInfo = getTokenInfo();
  const users = useSelector((state) => state.user.users);
  const user = useSelector((state) => state.user.user);
  const [visible, setVisible] = useState(false);
  const [internalUsers, setInternalUsers] = useState([]);
  

  useEffect(() => {
      if (users && users.length > 0) {
        setInternalUsers(users.filter((u) => u.isIntern));  
      }
    }, [users]); 
  

  useEffect(() => {
    if (
      userInfo.Roles !== undefined &&
      userInfo.Roles.includes("user.showAll")
    ) {
      dispatch(GetUsers(userInfo.Email, true));
    } else 
     {
      window.location.href = "/home";
    }
  }, [dispatch, userInfo.Email, userInfo.Roles]);

  const selectHanlder = (val) => {
    navigate(`/sign/${val.id}/request/create`);
  };

  const editHandlder = (val) => {
    navigate(`/users/edit/${val.id}`);
  };
  
  const backHanlder = () => {
    navigate(`/sign`);
  };

  let actions = [];
  const buttons = (rowData) => {
    let buttons = [];
    const buttonEdit = (
      <Button
        label="Seleccionar"
        icon="pi pi-chevron-circle-right"
        className="p-button-rounded p-button-text"
        onClick={() => {
          selectHanlder(rowData);
        }}
      />
    );
    const buttonView = <Button
    label="Editar"
    icon="pi pi-file-edit"
    className="p-button-rounded p-button-success p-button-text"
    onClick={() => {
      editHandlder(rowData);
    }}
  />;
  
    if (userInfo.Roles !== undefined && userInfo.Roles.includes("user.edit") 
      && rowData.email !== userInfo.Email
    ) {
      buttons.push(buttonEdit);
    }
    if (userInfo.Roles !== undefined && userInfo.Roles.includes("user.view") && rowData.profile === "PFnubeQABAPerteneciente" && rowData.email !== userInfo.Email) {
      buttons.push(buttonView);
    }
    return buttons;
  };
  actions.push(buttons);


  const columns = [
    {
      field: "name",
      header: "Nombre",
      filterMatchMode: "contains",
    },
    {
      field: "surname1",
      header: "Apellido",
      filterMatchMode: "contains",
    },
    {
      field: "identification",
      header: "Identificacion",
      filterMatchMode: "contains",
    },
    {
      field: "email",
      header: "Email",
      filterMatchMode: "contains",
    },
  ];


  return (
    <>
     
      <div
        style={{ backgroundColor: "#133047", padding: "1%", height: "118vh" }}
      >
        
        <ABADatatable
          width="20%"
          title="Por favor seleccione un persona"
          values={internalUsers}
          rows={5}
          rowsPerPageOptions={[5, 10, 20]}
          Columns={columns}
          actions={actions}
          createButton={{
            label: "Crear perteneciente",
            onClick: () => setVisible(true),
            permission: "user.create",
          }}
          backButton={{
            label: "Regresar",
            onClick: backHanlder,
            permission: "goBack",
          }        
        }
        />
        <Dialog
          header="Crear perteneciente"
          visible={visible}
          style={{ width: "50vw" }}
          onHide={() => {if (!visible) return; setVisible(false); }}
        >
          <p className="m-0">
            <UserForms actionUser={CreateUser} user={user} isModal={true} />
          </p>
        </Dialog>
      </div>
    </>
  );
};
export default SignUsers;
